import React, { memo } from 'react';

import classNames from "core/helpers/common/classNames";

import Select from "core/ui-kit/select";
import Checkbox from "core/ui-kit/checkbox";

import { useTranslation } from "core/hooks/useTranslation";

const ModalContent = ({
    setSelectedTimeZoneId,
    setIsDaylightChecked,
    usesDaylightSaving,
    selectedTimeZoneId,
    isDaylightChecked,
    timeZoneOptions,
    saving,
}) => {
    const { t } = useTranslation();

    return (
        <div className="rt--tz-select-control">
            <div className={
                classNames(
                    'rt--tz-select-control-content',
                    saving && 'rt--tz-select-control-content-saving')
            }>
                <Select
                    className="rt--select-field"
                    options={timeZoneOptions}
                    value={selectedTimeZoneId}
                    placeholder={`${t('backoffice.common.select')} ${t('backoffice.common.timezone')}`}
                    onChange={(value) => setSelectedTimeZoneId(value)}
                    showSelectedOption
                    search
                />
                {
                    usesDaylightSaving && (
                        <div className="rt--flex rt--align-items-center rt--mt-16">
                            <Checkbox
                                checked={isDaylightChecked}
                                onChange={(event) => setIsDaylightChecked(event.target.checked)}
                                className="rt--mr-8"
                            />
                            <span>
                                    {t('backoffice.common.daylightSavingTime')}
                                </span>
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default memo(ModalContent);
